import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    routes: [{
            path: '/',
            redirect: '/index/HomePage',
        },
        //登录
        {
            path: '/index/Login',
            name: 'Login',
            component: () => import('../view/UserViews/Login.vue')
        },
        {
            path: '/index/Register',
            name: 'Register',
            component: () => import('../view/UserViews/Register.vue')
        },
        //手机端扫描查看证书结果
        {
            path: '/index/CertQueryMobile',
            name: 'CertQueryMobile',
            component: () => import('../view/CertViews/CertQueryMobile.vue')
        },
        //手机端扫描查看证书结果-新
        {
            path: '/index/CertQueryMobileNew',
            name: 'CertQueryMobileNew',
            component: () => import('../view/CertViews/CertQueryMobileNew.vue')
        },
        //首页
        {
            path: '/index',
            name: 'index',
            component: () => import('../components/index.vue'),
            children: [
                //首页
                {
                    path: '/index/HomePage',
                    name: 'HomePage',
                    component: () => import('../components/HomePage.vue')
                },
                {
                    path: '/index/CertSearch',
                    name: 'CertSearch',
                    component: () => import('../view/CertViews/CertSearch.vue')
                },
                {
                    path: '/index/CertList',
                    name: 'CertList',
                    component: () => import('../view/CertViews/CertList.vue')
                },
                {
                    path: '/index/CertQuery',
                    name: 'CertQuery',
                    component: () => import('../view/CertViews/CertQuery.vue')
                },
                {
                    path: '/index/CourseVideo',
                    name: 'CourseVideo',
                    component: () => import('../view/VideoViews/Video1.vue')
                },
                //train
                {
                    path: '/index/TrainList',
                    name: 'TrainList',
                    component: () => import('../view/TrainViews/TrainList.vue')
                },
                //VIP
                {
                    path: '/index/VIP',
                    name: 'VIP',
                    component: () => import('../view/VIPViews/VIP.vue')
                },
                //企业入驻
                {
                    path: '/index/Entry',
                    name: 'Entry',
                    component: () => import('../view/AboutViews/Entry.vue')
                },
                //train
                {
                    path: '/index/TrainList',
                    name: 'TrainList',
                    component: () => import('../view/TrainViews/TrainList.vue')
                },
                {
                    path: '/index/TrainDetail',
                    name: 'TrainDetail',
                    component: () => import('../view/TrainViews/TrainDetail.vue')
                },

                //course
                {
                    path: '/index/CourseList',
                    name: 'CourseList',
                    component: () => import('../view/CourseViews/CourseList.vue')
                },
                {
                    path: '/index/CourseDetail',
                    name: 'CourseDetail',
                    component: () => import('../view/CourseViews/CourseDetail.vue')
                },

                //news
                {
                    path: '/index/NewsList',
                    name: 'NewsList',
                    component: () => import('../view/NewsViews/NewsList.vue')
                },
                {
                    path: '/index/NewsDetail',
                    name: 'NewsDetail',
                    component: () => import('../view/NewsViews/NewsDetail.vue')
                },

                //organ
                {
                    path: '/index/OrganList',
                    name: 'OrganList',
                    component: () => import('../view/NewsViews/OrganList.vue')
                },
                //动态详情
                {
                    path: '/index/OrganDetail',
                    name: 'OrganDetail',
                    component: () => import('../view/NewsViews/OrganDetail.vue')
                },
                // banner详情
                {
                    path: '/index/BannerDetail',
                    name: 'BannerDetail',
                    component: () => import('../view/NewsViews/BannerDetail.vue')
                },

                {
                    path: '/index/About',
                    name: 'About',
                    component: () => import('../view/AboutViews/About.vue')
                },
                {
                    path: '/index/AssociationList',
                    name: 'AssociationList',
                    component: () => import('../view/AssociationViews/AssociationList.vue')
                },
                {
                    path: '/index/AssociationDetail',
                    name: 'AssociationDetail',
                    component: () => import('../view/AssociationViews/AssociationDetail.vue')
                },
                {
                    path: '/index/CertAssociationDetail',
                    name: 'CertAssociationDetail',
                    component: () => import('../view/CertViews/CertAssociationDetail.vue')
                },
                //个人中心
                {
                    path: '/index/User',
                    name: 'User',
                    component: () => import('../view/UserViews/User.vue'),
                    children: [{
                            path: '/index/UserAccount',
                            name: 'UserAccount',
                            component: () => import('../view/UserViews/UserAccount.vue'),
                            children: [{
                                    path: '/index/UserInfo',
                                    name: 'UserInfo',
                                    component: () => import('../view/UserViews/UserInfo.vue'),
                                },
                                {
                                    path: '/index/UserSecurity',
                                    name: 'UserSecurity',
                                    component: () => import('../view/UserViews/UserSecurity.vue'),
                                }
                            ]
                        },
                        {
                            path: '/index/UserOrder',
                            name: 'UserOrder',
                            component: () => import('../view/UserViews/UserOrder.vue')
                        },
                        {
                            path: '/index/UserCourse',
                            name: 'UserCourse',
                            component: () => import('../view/UserViews/UserCourse.vue')
                        },
                        {
                            path: '/index/UserCert',
                            name: 'UserCert',
                            component: () => import('../view/UserViews/UserCert.vue')
                        }
                    ]
                },
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js